// API configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// API utility functions
export const api = {
  // Contact form submission
  submitContact: async (contactData: {
    name: string;
    phone: string;
    email: string;
    location: string;
    message: string;
  }) => {
    const response = await fetch(`${API_BASE_URL}/api/contact/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactData),
    });

    if (!response.ok) {
      throw new Error('Failed to submit contact form');
    }

    return response.json();
  },

  // Newsletter subscription (if you want to implement this later)
  subscribeNewsletter: async (email: string) => {
    // You can add this endpoint to your backend later
    const response = await fetch(`${API_BASE_URL}/api/newsletter/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error('Failed to subscribe to newsletter');
    }

    return response.json();
  },
};

export { API_BASE_URL };